import { login } from '../../Authentication/AuthenticationService';
import AppConstants from '../../AppConstants';

export function forceLoginIfExpired(error) {
  if (error && error.response && error.response.status === 401) {
    login();
  }
}

export function redirectToOldView() {
  window.location.href = `${AppConstants.G2W_BROKER_BASE_URL}/webinars.tmpl?classic=true`;
}

export function redirectToMyAccountPage() {
  window.location.href = `${AppConstants.MY_ACCOUNT_URL}`;
}



// WEBPACK FOOTER //
// ./src/Reducks/Utils/RedirectionUtils.js